import * as yup from 'yup';
import {
  BANNER_ACCEPTED_MIME_TYPES,
  BANNER_MAX_SIZE_BYTES,
  BannerText,
  BannerUrlText
} from './AddEventModal.constants';

export const validationSchema = yup.object({
  name: yup.string().required('Name is required field'),
  date: yup.string().required('Date is required field'),
  link: yup
    .string()
    .required('Link is required field')
    .test('link-validation', 'existing link input not found', (value) => {
      if (value) {
        try {
          new URL(value);
          return true;
        } catch (error) {
          return !value.includes('http://') && !value.includes('https://');
        }
      }
      return false;
    }),
  latitude: yup
    .string()
    .required('Latitude is required field')
    .test(
      'latitude-validation',
      'The latitude value must be between -90 and 90',
      (value) => {
        if (value === '' || value === '0.000000') {
          return false;
        }
        if (value) {
          return Number(value) >= -90 && Number(value) <= 90; // Aturan validasi kustom
        }
        return false;
      }
    ),
  longitude: yup
    .string()
    .required('Longitude is required field')
    .test(
      'longitude-validation',
      'The longitude value must be between -180 and 180',
      (value) => {
        if (value === '' || value === '0.000000') {
          return false;
        }
        if (value) {
          return Number(value) >= -180 && Number(value) <= 180; // Aturan validasi kustom
        }
        return false;
      }
    ),
  description: yup.string(),
  /**
   * The banner is optional: a submission with no file must stay valid, which is
   * why every test below short-circuits to true on an empty value. The rules
   * mirror the global-event service's own checks so the user is told before a
   * 5 MB upload is spent; the server remains the control.
   */
  banner: yup
    .mixed<File>()
    .nullable()
    .notRequired()
    .test('banner-format', BannerText.errorFormat, (value) => {
      if (!value) {
        return true;
      }
      return BANNER_ACCEPTED_MIME_TYPES.includes(value.type);
    })
    .test('banner-size', BannerText.errorSize, (value) => {
      if (!value) {
        return true;
      }
      return value.size <= BANNER_MAX_SIZE_BYTES;
    }),
  /**
   * Optional external video URL. Same shape as the `link` test above (parse
   * with the URL constructor, empty stays valid) with one deliberate
   * difference: the scheme must be http or https. `link` tolerates a
   * scheme-less value and would accept `javascript:` because that parses; this
   * value is handed to `window.open()` on the portal, so it is allowlisted
   * here instead. The server remains the control.
   */
  bannerUrl: yup
    .string()
    .notRequired()
    .test('banner-url-validation', BannerUrlText.errorFormat, (value) => {
      if (!value || value.trim() === '') {
        return true;
      }
      try {
        const { protocol } = new URL(value.trim());
        return protocol === 'http:' || protocol === 'https:';
      } catch (error) {
        return false;
      }
    })
});
